import { render, staticRenderFns } from "./seeAssessment.vue?vue&type=template&id=fcd6137c&scoped=true&"
import script from "./seeAssessment.vue?vue&type=script&lang=js&"
export * from "./seeAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd6137c",
  null
  
)

export default component.exports